import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaChevronRight from 'react-icons/lib/fa/chevron-right';

import A from 'wanderu-component-react-router-link';
import {
    CarrierLogo,
    Section,
    Typography,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

import localesConfig from '../../../config/homepage.locales';

import styles from './CarriersSection.scss';

const MAXIMUM_MOBILE_LOGOS = 14;

function CarriersSection(props) {
    const {
        carriers,
        locale,
        t,
    } = props;

    function _renderCarrier(carrier, index) {
        const {
            name,
            carrierCode,
            pageSlug,
        } = carrier;

        return (
            <A
                className={classNames(
                    styles.carrierCell,
                    { [styles.hiddenOnMobile]: index > MAXIMUM_MOBILE_LOGOS - 1 },
                )}
                href={`/carrier/${pageSlug}/`}
                key={`${name}-${locale}`}
            >
                <CarrierLogo
                    carrierCode={carrierCode}
                    carrierName={name}
                    height={21}
                    seoLazyload={true}
                    width={75}
                />
            </A>
        );
    }

    return (
        <Section className={styles.container}>
            <div className={styles.innerContainer}>
                <Typography className={styles.title} variant="h2">
                    {t('our-partners-include')}
                </Typography>
                <div className={styles.carrierGrid}>
                    {carriers.map(_renderCarrier)}
                    <A
                        className={styles.andManyMore}
                        href="/carrier/"
                    >
                        {t('and-many-more')}
                        <FaChevronRight />
                    </A>
                </div>
            </div>
        </Section>
    );
}

CarriersSection.propTypes = {
    carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
    locale: PropTypes.string.isRequired,
};

export { CarriersSection };
export default localize(CarriersSection, localesConfig.namespace);
